
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 
const GetShippingPerformance =( )   =>
request({
  url: ApiURL.Query.GetShippingPerformance,
  method: RequestType.GET,
  //params:params,
}); 

 
const ShipingPerformanceQuery = {
  GetShippingPerformance 
};

export default ShipingPerformanceQuery;
